module.exports = __webpack_public_path__ + "static/img/RC12V_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RC12V_1.png
// module id = YbkE
// module chunks = 0